import ContextMenu from 'src/components/common/ContextMenu';
import * as React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import Office from 'src/models/Office';
import FormButton from 'src/components/controls/forms/redesign/FormButton';
import { IRootState } from 'src/reducers';
import selectors from 'src/selectors';
import actions from 'src/actions';
import AdminDirectoryLayout from './AdminDirectoryLayout';

interface IAdminOfficePageProps {
    isLoading: boolean;
    offices: Office[] | undefined;
    getOffices: () => void;
    deleteOffice: (id: number) => void;
    navigate: (path: string) => void;
}

export class AdminOfficePage extends React.Component<IAdminOfficePageProps> {
    componentDidMount() {
        this.props.getOffices();
    }

    render() {
        const { offices, isLoading, navigate, deleteOffice } = this.props;
        return (
            <AdminDirectoryLayout
                title="Office Management"
                subtitle="Create and maintain office locations."
                action={<FormButton text="Add Office" intent="primary" onClick={() => navigate('/admin/create-office')} />}
            >
                <div className="admin-directory-table-wrapper" aria-busy={isLoading}>
                    <table className="admin-directory-table admin-offices-table">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col">Address</th>
                                <th scope="col">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading ? (
                                <tr>
                                    <td colSpan={3} role="status">
                                        Loading offices...
                                    </td>
                                </tr>
                            ) : offices?.length ? (
                                offices.map((office) => (
                                    <tr key={office.id}>
                                        <td>{office.name}</td>
                                        <td>
                                            <div>{office.address?.addressLine1}</div>
                                            <div>{office.address?.addressLine2}</div>
                                            <div>
                                                {[office.address?.city, office.address?.state?.abbreviation, office.address?.zipCode]
                                                    .filter(Boolean)
                                                    .join(' ')}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="admin-directory-actions">
                                                <ContextMenu
                                                    isVisible={true}
                                                    actions={[
                                                        { text: 'Edit Office', action: () => navigate(`/admin/edit-office/${office.id}`) },
                                                        { text: 'Delete Office', action: () => deleteOffice(office.id) },
                                                    ]}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={3} role="status">
                                        No offices available.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </AdminDirectoryLayout>
        );
    }
}

const mapStateToProps = (state: IRootState) => ({
    isLoading: selectors.office.isLoadingOffices(state),
    offices: selectors.office.offices(state),
});

export default connect(mapStateToProps, {
    getOffices: actions.office.getOffices,
    deleteOffice: actions.office.deleteOffice,
    navigate: (path: string) => push(path),
})(AdminOfficePage);



// WEBPACK FOOTER //
// ./src/components/admin/sections/AdminOfficesPage.tsx